window.theme = window.theme || {};
(function ($) {
  "use strict";

  var Beauty = {
    init: function () {
      this.Basic.init();
    },

    Basic: {
      init: function () {
        this.smoothScroll();
        this.slideshowSwiper();
      },

      smoothScroll: function () {
        $('a[href*="#"]')
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function (event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate(
                  {
                    scrollTop: target.offset().top,
                  },
                  600,
                  function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                      // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    }
                  }
                );
              }
            }
          });
      },
      slideshowSwiper: function () {
        class slideshowSwiper extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.sliderWrapper = this.querySelector(".slideshow__swiper");
            if (!this.sliderWrapper) return;
            const resizeObserver = new ResizeObserver((entries) => this.init());
            resizeObserver.observe(this.sliderWrapper);
            //  console.log("testdd",this.sliderWrapper.dataset)
          }
          init() {
            let centered_slides =
              this.sliderWrapper.dataset.centeredslides !== undefined
                ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
                : undefined;
            let effect_fade =
              this.sliderWrapper.dataset.effectfade !== undefined
                ? JSON.parse(this.sliderWrapper.dataset.effectfade)
                : undefined;
           

            let next = this.querySelector(".swiper-button-next");
            let prev = this.querySelector(".swiper-button-prev");
            let pagination = this.querySelector(".swiper-pagination");
           
            const slider = new Swiper(this.sliderWrapper, {
              effect: effect_fade ? "fade" : "slide",
              centeredSlides: centered_slides ? centered_slides : false,
              slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
              spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              grabCursor: true,
              horizontal: true,
              watchSlidesProgress: true,
              draggable: !0,
              autoHeight: !1,
              watchOverflow: !0,
              threshold: 10,
              freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
              loop: JSON.parse(this.sliderWrapper.dataset.loop),
              speed: 700,
              mousewheel: {
                forceToAxis: true,
              },
              autoplay: {
                enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
                disableOnInteraction: false,
                delay: parseInt(this.sliderWrapper.dataset.delay)
              },
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
              pagination: {
                el: pagination,
                clickable: true
              },
              breakpoints: {
                359: {
                  slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                  spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
                },
                768: {
                  slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                  spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
                },
                1024: {
                  slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                  spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
                },
              },
            });

            return slider;
          }
        }
        customElements.define("slideshow-swiper", slideshowSwiper);
      },
      
    },
  };
  

  jQuery(document).ready(function () {
    Beauty.init();
  });
})(jQuery);




$('.collapsable__head').on('click', function() {
  // if($(this).hasClass('active')) {
  // $(this).siblings('.collapsable__content').slideUp();
  // $(this).removeClass('active');
  // }
  // else {
  // $('.collapsable__content').slideUp();
  // $('.collapsable__head').removeClass('active');
  $(this).siblings('.collapsable__content').slideToggle();
  $(this).toggleClass('active');
  // }
}); 


class LogoListSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.logoListSwiper = this.querySelector(".logo-list-swiper");

    if (!this.logoListSwiper) return;

    this.initSlider();
  }

  initSlider() {
    const slidesPerView = parseInt(this.dataset.slidesPerView) || 6;
    const loop = JSON.parse(this.dataset.loop);
    const autoplay = JSON.parse(this.dataset.autoplay);
    const delay = parseInt(this.dataset.delay) || 3000;

    new Swiper(this.logoListSwiper, {
      slidesPerView: slidesPerView,
      spaceBetween: 120,
      loop: loop,
      autoplay: {
        enabled: autoplay,
        delay: delay,
        disableOnInteraction: false,
      },
      pagination: false,
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 3, // Mobile
          spaceBetween: 50,
        },
        768: {
          slidesPerView: 4, // Tablet
        },
        1024: {
          slidesPerView: 5, // Tab
          spaceBetween: 120,
        },
        1180: {
          slidesPerView: slidesPerView, // Desktop
          spaceBetween: 120,
        },
      },
    });
  }
}

customElements.define("logo-list-slider", LogoListSlider);


class ReviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.reviewSwiper = this.querySelector(".review-swiper");

    if (!this.reviewSwiper) return;

    this.initSlider();
  }

  initSlider() {
    const slidesPerView = parseInt(this.dataset.slidesPerView) || 3;
    const loop = JSON.parse(this.dataset.loop);
    const autoplay = JSON.parse(this.dataset.autoplay);
    const delay = parseInt(this.dataset.delay) || 3000;

    new Swiper(this.reviewSwiper, {
      slidesPerView: slidesPerView,
      spaceBetween: 80,
      loop: loop,
      autoplay: {
        enabled: autoplay,
        delay: delay,
        disableOnInteraction: false,
      },
      pagination: false,
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 2, // Mobile
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2, // Tablet
        },
        1024: {
          slidesPerView: 2, // Tab
          spaceBetween: 50,
        },
        1180: {
          slidesPerView: slidesPerView, // Desktop
          spaceBetween: 80,
        },
      },
    });
  }
}

customElements.define("review-slider", ReviewSlider);




var SHTHelper = window.SHTHelper || {};
SHTHelper.qs = document.querySelector.bind(document);
SHTHelper.qsa = document.querySelectorAll.bind(document);
SHTHelper.qid = document.getElementById.bind(document);
SHTHelper.qde = document.documentElement;

class SHTLazyLoadingVideo extends HTMLElement {
    constructor() {
      super(),
        (this.iframe = this.querySelector("iframe")),
        (this.template = this.querySelector("template")),
        (this.isMouseenter = !1);
    }
    loadVideo() {
      var t;
      this.iframe &&
        (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
        this.iframe.addEventListener(
          "load",
          function () {
            "youtube" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              ),
              "vimeo" == this.dataVideoType &&
                this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }.bind(this)
        )),
        "local_video" == this.dataVideoType &&
          ((this.local_video = this.querySelector("video")),
          (t = this.local_video.querySelector("source").getAttribute("data-src")),
          (this.local_video.src = t));
    }
    execute() {
      Shopify.designMode
        ? this.loadVideo()
        : (["mousemove", "touchstart"].forEach(
            function (t) {
              SHTHelper.qs("body").addEventListener(
                t,
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              );
            }.bind(this)
          ),
          window.addEventListener(
            "scroll",
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          ));
    }
    static get observedAttributes() {
      return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(t) {
      this.setAttribute("data-video-type", t);
    }
    get dataVideoType() {
      return this.getAttribute("data-video-type");
    }
    set dataVideoId(t) {
      this.setAttribute("data-video-id", t);
    }
    get dataVideoId() {
      return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(t, e, s) {
      e !== s && this.execute();
    }
    connectedCallback() {
      this.execute();
    }
    disconnectedCallback() {}
  }
customElements.define("sht-load-video", SHTLazyLoadingVideo);


class BlogSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.reviewSwiper = this.querySelector(".blog-swiper");

    if (!this.reviewSwiper) return;

    this.initSlider();
  }

  initSlider() {
    const slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    const loop = JSON.parse(this.dataset.loop);
    const autoplay = JSON.parse(this.dataset.autoplay);
    const delay = parseInt(this.dataset.delay) || 3000;

    new Swiper(this.reviewSwiper, {
      slidesPerView: slidesPerView,
      spaceBetween: 40,
      centeredSlides: true,
      loop: loop,
      autoplay: {
        enabled: autoplay,
        delay: delay,
        disableOnInteraction: false,
      },
      pagination: false,
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 1.1, // Mobile
          spaceBetween: 20,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 2, // Tablet
        },
        1024: {
          slidesPerView: 2, // Tab
          spaceBetween: 40,
        },
        1180: {
          slidesPerView: slidesPerView, // Desktop
          spaceBetween: 40,
        },
      },
    });
  }
}

customElements.define("blog-slider", BlogSlider);


